var removeClassesWithPrefix = function removeClassesWithPrefix(prefix) {
  return function (classList) {
    return classList.split(" ").filter(function (className) {
      return className.lastIndexOf(prefix, 0) !== 0;
    }).join(" ").trim();
  };
};

export default removeClassesWithPrefix;